module.exports = __webpack_public_path__ + "img/open-aire-logo.f8d3e1ec.png";